var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('lang-box',{staticClass:"lang-container"}),(_vm.$route.path !== '/')?_c('div',{staticClass:"nav"},[_c('LeftBar',{attrs:{"alpha":_vm.alpha}})],1):_vm._e(),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }